import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-lingo-function',
  templateUrl: './ddc-lingo-function.component.html',
  styleUrl: './ddc-lingo-function.component.scss',
  imports: [AngularMaterialsModules, CommonModule],
})
export class DdcLingoFunctionComponent implements OnDestroy {
  @Input() tooltip: string = 'Ask Lingo AI'

  _isDarkTheme: boolean = false
  private _themeSubscription: Subscription

  get logoSrc(): string {
    return this._isDarkTheme
      ? 'assets/media/logos/lingo_logo_dark.png'
      : 'assets/media/logos/lingo_logo_light.png'
  }

  constructor(public themeService: ThemeService) {
    this._themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === Themes.DARK
    })
  }

  ngOnDestroy(): void {
    this._themeSubscription.unsubscribe()
  }
}
